shadow$provide[513] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, ReversedDepthFuncs:{enumerable:true, get:function() {
  return ReversedDepthFuncs;
}}, arrayMax:{enumerable:true, get:function() {
  return arrayMax;
}}, arrayMin:{enumerable:true, get:function() {
  return arrayMin;
}}, arrayNeedsUint32:{enumerable:true, get:function() {
  return arrayNeedsUint32;
}}, createCanvasElement:{enumerable:true, get:function() {
  return createCanvasElement;
}}, createElementNS:{enumerable:true, get:function() {
  return createElementNS;
}}, error:{enumerable:true, get:function() {
  return error;
}}, getConsoleFunction:{enumerable:true, get:function() {
  return getConsoleFunction;
}}, getTypedArray:{enumerable:true, get:function() {
  return getTypedArray;
}}, isTypedArray:{enumerable:true, get:function() {
  return isTypedArray;
}}, log:{enumerable:true, get:function() {
  return log;
}}, probeAsync:{enumerable:true, get:function() {
  return probeAsync;
}}, setConsoleFunction:{enumerable:true, get:function() {
  return setConsoleFunction;
}}, toNormalizedProjectionMatrix:{enumerable:true, get:function() {
  return toNormalizedProjectionMatrix;
}}, toReversedProjectionMatrix:{enumerable:true, get:function() {
  return toReversedProjectionMatrix;
}}, warn:{enumerable:true, get:function() {
  return warn;
}}, warnOnce:{enumerable:true, get:function() {
  return warnOnce;
}}, yieldToMain:{enumerable:true, get:function() {
  return yieldToMain;
}}});
var require$_DOT__SLASH_constants_DOT_js = require("./constants.js");
function arrayMin(array) {
  if (array.length === 0) {
    return Infinity;
  }
  let min = array[0];
  for (let i = 1, l = array.length; i < l; ++i) {
    if (array[i] < min) {
      min = array[i];
    }
  }
  return min;
}
function arrayMax(array) {
  if (array.length === 0) {
    return -Infinity;
  }
  let max = array[0];
  for (let i = 1, l = array.length; i < l; ++i) {
    if (array[i] > max) {
      max = array[i];
    }
  }
  return max;
}
function arrayNeedsUint32(array) {
  for (let i = array.length - 1; i >= 0; --i) {
    if (array[i] >= 65535) {
      return true;
    }
  }
  return false;
}
const TYPED_ARRAYS = {Int8Array:Int8Array, Uint8Array:Uint8Array, Uint8ClampedArray:Uint8ClampedArray, Int16Array:Int16Array, Uint16Array:Uint16Array, Int32Array:Int32Array, Uint32Array:Uint32Array, Float32Array:Float32Array, Float64Array:Float64Array};
function getTypedArray(type, buffer) {
  return new TYPED_ARRAYS[type](buffer);
}
function isTypedArray(array) {
  return ArrayBuffer.isView(array) && !(array instanceof DataView);
}
function createElementNS(name) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", name);
}
function createCanvasElement() {
  const canvas = createElementNS("canvas");
  canvas.style.display = "block";
  return canvas;
}
const _cache = {};
let _setConsoleFunction = null;
function setConsoleFunction(fn) {
  _setConsoleFunction = fn;
}
function getConsoleFunction() {
  return _setConsoleFunction;
}
function log(...params) {
  const message = "THREE." + params.shift();
  if (_setConsoleFunction) {
    _setConsoleFunction("log", message, ...params);
  } else {
    console.log(message, ...params);
  }
}
function enhanceLogMessage(params) {
  const message = params[0];
  if (typeof message === "string" && message.startsWith("TSL:")) {
    const stackTrace = params[1];
    if (stackTrace && stackTrace.isStackTrace) {
      params[0] += " " + stackTrace.getLocation();
    } else {
      params[1] = 'Stack trace not available. Enable "THREE.Node.captureStackTrace" to capture stack traces.';
    }
  }
  return params;
}
function warn(...params) {
  params = enhanceLogMessage(params);
  const message = "THREE." + params.shift();
  if (_setConsoleFunction) {
    _setConsoleFunction("warn", message, ...params);
  } else {
    const stackTrace = params[0];
    if (stackTrace && stackTrace.isStackTrace) {
      console.warn(stackTrace.getError(message));
    } else {
      console.warn(message, ...params);
    }
  }
}
function error(...params) {
  params = enhanceLogMessage(params);
  const message = "THREE." + params.shift();
  if (_setConsoleFunction) {
    _setConsoleFunction("error", message, ...params);
  } else {
    const stackTrace = params[0];
    if (stackTrace && stackTrace.isStackTrace) {
      console.error(stackTrace.getError(message));
    } else {
      console.error(message, ...params);
    }
  }
}
function warnOnce(...params) {
  const message = params.join(" ");
  if (message in _cache) {
    return;
  }
  _cache[message] = true;
  warn(...params);
}
function yieldToMain() {
  if (typeof self !== "undefined" && typeof self.scheduler !== "undefined" && typeof self.scheduler.yield !== "undefined") {
    return self.scheduler.yield();
  }
  return new Promise(resolve => {
    requestAnimationFrame(resolve);
  });
}
function probeAsync(gl, sync, interval) {
  return new Promise(function(resolve, reject) {
    function probe() {
      switch(gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)) {
        case gl.WAIT_FAILED:
          reject();
          break;
        case gl.TIMEOUT_EXPIRED:
          setTimeout(probe, interval);
          break;
        default:
          resolve();
      }
    }
    setTimeout(probe, interval);
  });
}
function toNormalizedProjectionMatrix(projectionMatrix) {
  const m = projectionMatrix.elements;
  m[2] = 0.5 * m[2] + 0.5 * m[3];
  m[6] = 0.5 * m[6] + 0.5 * m[7];
  m[10] = 0.5 * m[10] + 0.5 * m[11];
  m[14] = 0.5 * m[14] + 0.5 * m[15];
}
function toReversedProjectionMatrix(projectionMatrix) {
  const m = projectionMatrix.elements;
  const isPerspectiveMatrix = m[11] === -1;
  if (isPerspectiveMatrix) {
    m[10] = -m[10] - 1;
    m[14] = -m[14];
  } else {
    m[10] = -m[10];
    m[14] = -m[14] + 1;
  }
}
const ReversedDepthFuncs = {[require$_DOT__SLASH_constants_DOT_js.NeverDepth]:require$_DOT__SLASH_constants_DOT_js.AlwaysDepth, [require$_DOT__SLASH_constants_DOT_js.LessDepth]:require$_DOT__SLASH_constants_DOT_js.GreaterDepth, [require$_DOT__SLASH_constants_DOT_js.EqualDepth]:require$_DOT__SLASH_constants_DOT_js.NotEqualDepth, [require$_DOT__SLASH_constants_DOT_js.LessEqualDepth]:require$_DOT__SLASH_constants_DOT_js.GreaterEqualDepth, [require$_DOT__SLASH_constants_DOT_js.AlwaysDepth]:require$_DOT__SLASH_constants_DOT_js.NeverDepth, 
[require$_DOT__SLASH_constants_DOT_js.GreaterDepth]:require$_DOT__SLASH_constants_DOT_js.LessDepth, [require$_DOT__SLASH_constants_DOT_js.NotEqualDepth]:require$_DOT__SLASH_constants_DOT_js.EqualDepth, [require$_DOT__SLASH_constants_DOT_js.GreaterEqualDepth]:require$_DOT__SLASH_constants_DOT_js.LessEqualDepth,};

};